<template>
  <router-view></router-view> 
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
@import url('https://cdn-uicons.flaticon.com/2.0.0/uicons-regular-rounded/css/uicons-regular-rounded.css');
@import url('https://cdn-uicons.flaticon.com/2.0.0/uicons-regular-straight/css/uicons-regular-straight.css');
</style>
